export default {
  darkmode: false,
};
